// src/components/quiz/quizShared.js
// Utility e piccoli componenti UI condivisi tra le 3 modalità di FantaQuizz.
import React from 'react';
import { Crown, Medal, CheckCircle2, XCircle } from 'lucide-react';
import { MANTRA_ROLE_THEME } from '../auction/MantraRoleConfiguration';

export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function fmtTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function fmtNum(v, dec = 0) {
  const n = Number(v || 0);
  return dec > 0 ? n.toFixed(dec) : String(Math.round(n));
}

// Rimuove accenti/casing per il match di ricerca (autocomplete "Indovina il
// giocatore"), stesso approccio già usato altrove nell'app (es. AuctionMarketTab).
export function normalizeText(value = '') {
  return String(value)
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

// Codice breve e stabile derivato dall'account (email/uid), non reversibile:
// serve solo a distinguere due persone diverse con lo stesso nome e cognome
// senza mostrare pubblicamente l'email.
export function shortAccountCode(entry) {
  const seed = String(entry?.email || entry?.userId || entry?.id || '').trim().toLowerCase();
  if (!seed) return '';
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return h.toString(36).slice(-3).toUpperCase();
}

export function RankMedal({ rank }) {
  if (rank === 0) return <Crown size={14} className="quiz-medal quiz-medal--gold" />;
  if (rank === 1) return <Medal size={14} className="quiz-medal quiz-medal--silver" />;
  if (rank === 2) return <Medal size={14} className="quiz-medal quiz-medal--bronze" />;
  return <span className="quiz-rank-num">{rank + 1}</span>;
}

export const LETTERS = ['A', 'B', 'C', 'D'];

// Chip colorate dei token Mantra (Ds, Dc, W, T…), stessa palette usata in
// Simula rosa / tab asta. Usate quando un'opzione porta `roleTokens`.
export function MantraTokenChips({ tokens = [] }) {
  return (
    <span className="quiz-role-chips">
      {tokens.map((token) => {
        const theme = MANTRA_ROLE_THEME[token] || MANTRA_ROLE_THEME.A;
        return (
          <span
            key={token}
            className="quiz-role-chip"
            style={{ background: theme.bg, border: `1px solid ${theme.border}`, color: theme.color }}
          >
            {token}
          </span>
        );
      })}
    </span>
  );
}

export function OptionBtn({ option, letter, onClick, state }) {
  // state: null | 'selected' | 'correct' | 'wrong' | 'dimmed'
  const revealed = state !== null && state !== undefined && state !== 'idle';
  const hasRoleTokens = Array.isArray(option.roleTokens) && option.roleTokens.length > 0;
  return (
    <button
      type="button"
      className={`quiz-option quiz-option--${state || 'idle'}`}
      onClick={onClick}
      disabled={revealed}
    >
      <span className="quiz-option__letter">{letter}</span>
      <div className="quiz-option__body">
        {hasRoleTokens ? <MantraTokenChips tokens={option.roleTokens} /> : <strong>{option.label}</strong>}
        {option.sub && <span>{option.sub}</span>}
      </div>
      {revealed && option.statValue != null && (
        <span className="quiz-option__value">{option.statValue}</span>
      )}
      {state === 'correct' && <CheckCircle2 size={18} className="quiz-option__icon" />}
      {state === 'wrong' && <XCircle size={18} className="quiz-option__icon" />}
    </button>
  );
}
